import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// TYPES
import { APP, type AppStateType, Dictionary } from '@/types/app.types';

const initialState: AppStateType = {
  maintenanceMode: false,
  dictionary: {
    navigation: [],
    partners: [],
  },
  loadings: {
    dictionary: false,
    switchPartner: false,
  },
};

export const appSlice = createSlice({
  name: APP,
  initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.maintenanceMode = action.payload;
    },
    getAppDictionary: state => {
      state.loadings.dictionary = true;
    },
    getAppDictionarySuccess: (state, action: PayloadAction<{ data: Dictionary }>) => {
      state.loadings.dictionary = false;
      state.dictionary.navigation = action.payload.data.navigation || [];
      state.dictionary.partners = action.payload.data.partners || [];
    },
    getAppDictionaryFail: (state, _: PayloadAction) => {
      state.loadings.dictionary = false;
    },
    switchDefaultPartner: (
      state,
      _: PayloadAction<{ partnerId: number; onSuccess?: () => void }>,
    ) => {
      state.loadings.switchPartner = true;
    },
    switchDefaultPartnerSuccess: (state, _: PayloadAction) => {
      state.loadings.switchPartner = false;
    },
    switchDefaultPartnerFail: (state, _: PayloadAction) => {
      state.loadings.switchPartner = false;
    },
  },
});

export const {
  getAppDictionary: getAppDictionaryAction,
  getAppDictionarySuccess: getAppDictionarySuccessAction,
  getAppDictionaryFail: getAppDictionaryFailAction,
  switchDefaultPartner: switchDefaultPartnerAction,
  switchDefaultPartnerSuccess: switchDefaultPartnerSuccessAction,
  switchDefaultPartnerFail: switchDefaultPartnerFailAction,
} = appSlice.actions;

export default appSlice.reducer;
